import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ComandaService } from '../../../services/comanda.service';
import { Comanda } from '../../../models/comanda.model';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';

@Component({
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule, TableModule, TagModule],
  selector: 'app-view-comanda',
  templateUrl: './view-comanda.component.html',
  styleUrls: ['./view-comanda.component.css'],
})
export class ViewComandaComponent implements OnInit {
  comanda: Comanda | null = null;
  loading = true;
  id?: number;

  constructor(
    private comandaService: ComandaService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    if (this.id) {
      this.comandaService.find(this.id).subscribe({
        next: (response) => {
          this.comanda = response.data ?? null;
          this.loading = false;
        },
        error: () => {
          this.comanda = null;
          this.loading = false;
        },
      });
    } else {
      this.loading = false;
    }
  }

  goBack(): void {
    this.location.back();
  }

  fechar(): void {
    if (!this.id || this.comanda?.status !== 'ABERTA') return;
    if (!confirm('Fechar esta comanda? As mesas vinculadas serão liberadas.')) return;
    this.comandaService.fechar(this.id).subscribe({
      next: (response) => {
        this.comanda = response.data ?? this.comanda;
      },
      error: () => alert('Erro ao fechar comanda.'),
    });
  }

  cancelar(): void {
    if (!this.id || this.comanda?.status !== 'ABERTA') return;
    if (!confirm('Cancelar esta comanda? As mesas vinculadas serão liberadas.')) return;
    this.comandaService.cancelar(this.id).subscribe({
      next: (response) => {
        this.comanda = response.data ?? this.comanda;
      },
      error: () => alert('Erro ao cancelar comanda.'),
    });
  }

  formatDate(value: string | null | undefined): string {
    if (!value) return '—';
    try {
      const d = new Date(value);
      return isNaN(d.getTime()) ? value : d.toLocaleString('pt-BR');
    } catch {
      return value;
    }
  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case 'ABERTA': return 'success';
      case 'FECHADA': return 'secondary';
      case 'CANCELADA': return 'danger';
      default: return 'secondary';
    }
  }
}
